export const LOADING_START = 'LOADING_START'
export const LOADING_STOP = 'LOADING_STOP'
export const LOADING_RESET = 'LOADING_RESET'

export const defaultLodingState = {
  loading: 0
}

export default (state = defaultLodingState, action) => {
  switch (action.type) {
    case LOADING_START:
      return {
        ...state,
        loading: state.loading+1
      }
    case LOADING_STOP:
      return {
        ...state,
        loading: state.loading-1
      }
    case LOADING_RESET:
    return {
      ...state,
      loading: 0
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/loadingReducer.js